import { render, staticRenderFns } from "./TournamentBulletinDetail.vue?vue&type=template&id=570fc2c8&"
import script from "./TournamentBulletinDetail.vue?vue&type=script&lang=js&"
export * from "./TournamentBulletinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports